import { render, staticRenderFns } from "./FiltersSelect.vue?vue&type=template&id=151c3dfc&scoped=true"
import script from "./FiltersSelect.vue?vue&type=script&lang=js"
export * from "./FiltersSelect.vue?vue&type=script&lang=js"
import style0 from "./FiltersSelect.vue?vue&type=style&index=0&id=151c3dfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151c3dfc",
  null
  
)

export default component.exports